"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RotaStatsLoader = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const __1 = require("../..");
const placeholder_1 = __importDefault(require("../placeholder"));
const StatsWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
`;
const Item = styled_components_1.default.div `
  display: grid;
  grid-template-columns: auto auto;
  align-items: flex-end;
  grid-gap: 4px;
`;
const ItemValue = styled_components_1.default.div `
  font-size: 24px;
  line-height: 24px;
  font-weight: 400;
  margin-right: 8px;
  color: ${({ theme }) => theme.text.primary};
`;
const ItemLabel = styled_components_1.default.div `
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.text.secondary};
`;
const RotaStatsLoader = ({ count = 5 }) => {
    return (react_1.default.createElement(StatsWrapper, null, Array.from({ length: count }).map((_, idx) => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Item, { style: { width: 150 } },
            react_1.default.createElement(ItemValue, { style: { width: 40 } },
                react_1.default.createElement(placeholder_1.default, null)),
            react_1.default.createElement(ItemLabel, { style: { width: 100 } },
                react_1.default.createElement(placeholder_1.default, { size: 24 }))),
        idx !== count - 1 && react_1.default.createElement(__1.RotaDivider, { vertical: true, height: 40 }))))));
};
exports.RotaStatsLoader = RotaStatsLoader;
const Stats = ({ stats }) => {
    return (react_1.default.createElement(StatsWrapper, null, stats.map(({ label, value }, idx) => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Item, null,
            react_1.default.createElement(ItemValue, null, value),
            react_1.default.createElement(ItemLabel, null, label)),
        idx !== stats.length - 1 && react_1.default.createElement(__1.RotaDivider, { vertical: true, height: 40 }))))));
};
exports.default = Stats;
